import { useEffect } from 'react';
import { states } from '@/constants/lifecycle';
import { datasetSourceFromUrl } from '../helper';

const useFetchOrNewDataset = (fetch, newDataset, category, code, readStatus, isNew, datasetUrl) => {
  useEffect(() => {
    if (readStatus !== states.NONE) return;
    if (isNew) {
      const { datasetSourceType, datasetSourceCode } = datasetSourceFromUrl(datasetUrl);
      newDataset(category, code, datasetSourceType, datasetSourceCode);
    } else { fetch(category, code); }
  }, []);
};

const useFetchDatasetActions = (fetch, category, code, readStatus, actionsReadStatus, isNew) => {
  useEffect(() => {
    if (readStatus === states.SUCCESS && actionsReadStatus === states.NONE && !isNew) {
      fetch(category, code);
    }
  }, [readStatus]);
};

export default {
  useFetchOrNewDataset,
  useFetchDatasetActions,
};
